import { RadioGroupProps } from './Form.type'

const RadioGroup = ({
  title,
  name,
  id,
  options,
  selectedOption,
  onChange,
  disabled
}: RadioGroupProps) => (
  <div>
    <p
      className={`mb-3 text-center text-lg font-semibold text-teal-600 ${disabled && 'opacity-50'}`}
    >
      {title}
    </p>
    <div
      className={`flex flex-wrap justify-center gap-2 ${disabled && 'cursor-not-allowed opacity-50'}`}
    >
      {options.map((option) => (
        <label
          key={option}
          className={`flex cursor-pointer items-center rounded-md border-2 bg-white text-lg font-bold ${disabled && 'cursor-not-allowed'} ${
            selectedOption === option ? 'border-teal-600 bg-teal-200/35' : 'border-gray-300'
          }`}
        >
          <input
            type="radio"
            name={name}
            id={id || name}
            value={option}
            checked={selectedOption === option}
            onChange={onChange}
            className="hidden"
            disabled={disabled}
          />
          <span className={`text-gray-700 ${disabled && 'cursor-not-allowed'} px-6 py-4`}>
            {option}
          </span>
        </label>
      ))}
    </div>
  </div>
)

export default RadioGroup
